import Header from "./Header";
import Footer from "./Footer";
import FloatingContactActions from "./FloatingContactActions";
import ChatWidget from "../ChatWidget";

export default function Layout({ children }) {
  return (
    <div className="min-h-screen flex flex-col bg-brand-bg text-brand-text font-body">
      <Header />
      <main className="flex-1">{children}</main>
      <ChatWidget />
      <FloatingContactActions />
      <Footer />
    </div>
  );
}
